import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { TShareLinkModalTableProps } from '@components/ShareLinkModal/ShareLinkModal.types';
import { ShareLinkModalTableCell } from '@components/ShareLinkModal/_partials/ShareLinkModalTableCell';
import { useStoreState } from 'easy-peasy';
import { jobClientSelector } from '@model/Job/Job.selectors';
import { useParams } from 'react-router-dom';
import { useUserPackageVisibility } from '@components/ShareLinkModal/_hooks/use-user-package-visibility';

export const ShareLinkModalTable: FC<TShareLinkModalTableProps> = props => {
  const { items, setAlertDetail, jobId: jobIdProp } = props;

  const userPackageVisibility = useUserPackageVisibility();

  const { jobId, entityId } = useParams<{
    jobId?: string;
    entityId?: string;
  }>();

  const shareLinkJobId = jobIdProp ?? entityId ?? jobId;

  const mainRecipient = useStoreState(jobClientSelector);

  const { t } = useTranslation('', {
    keyPrefix: 'modal.share.table',
  });

  if ((!items.length && !mainRecipient) || !shareLinkJobId) {
    return null;
  }

  return (
    <div className="c-share-link-modal__table-container">
      <table className="c-share-link-modal__table">
        <thead>
          <tr>
            <th className="c-share-link-modal__table__header-cell c-share-link-modal__table__cell">
              {t('header.name')}
            </th>
            <th className="c-share-link-modal__table__header-cell c-share-link-modal__table__cell">
              {t('header.email')}
            </th>
            {userPackageVisibility.isVisible && (
              <>
                <th className="c-share-link-modal__table__header-cell c-share-link-modal__table__cell">
                  {t('header.compensationVisibility')}
                </th>
                <th className="c-share-link-modal__table__header-cell "></th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {mainRecipient && (
            <ShareLinkModalTableCell
              index={-1}
              isMainClient
              item={{
                clientId: mainRecipient.id,
                jobId: shareLinkJobId,
                clientFirstName: mainRecipient.firstName,
                clientLastName: mainRecipient.lastName,
                clientEmail: mainRecipient.email,
                isCompensationPackageVisible: true,
              }}
            />
          )}
          {items.map((item, index) => (
            <ShareLinkModalTableCell
              key={index}
              index={index}
              item={item}
              jobId={shareLinkJobId}
              setAlertDetail={setAlertDetail}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};
